(function () {
  let cartPromise = null;

  const CART_ICON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40"><path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 0 0-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0 0 20.5 6.5m3.75 5.31v-.56a3.75 3.75 0 1 0-7.5 0v.56zm-7.5 1h7.5v.56a3.75 3.75 0 1 1-7.5 0zm-1 0v.56a4.75 4.75 0 1 0 9.5 0v-.56h2.22l.71 10.67a4 4 0 0 1-3.99 4.27h-7.38a4 4 0 0 1-4-4.27l.72-10.67z"/></svg>';

  function getCart(forceRefresh) {
    if (!cartPromise || forceRefresh) {
      cartPromise = fetch('/cart.js')
        .then((res) => res.json())
        .catch(() => ({ items: [] }));
    }
    return cartPromise;
  }

  // Card markup (snippets/card-product.liquid) always renders a link with an
  // id ending in "-{{ card_product.id }}" (CardLink-... or
  // StandardCardNoMediaLink-...), so the trailing numeric segment is the
  // product id — no extra network request needed to know which product a
  // card represents.
  function getProductId(cardWrapper) {
    const link = cardWrapper.querySelector('[id^="CardLink-"], [id^="StandardCardNoMediaLink-"]');
    if (!link) return null;
    const match = link.id.match(/-(\d+)$/);
    return match ? match[1] : null;
  }

  // .card__inner is sized to exactly match the image (Dawn's aspect-ratio
  // padding-bottom trick), so appending here positions the button/badge
  // against the image's true box. Appending inside .card__media itself
  // doesn't work: Dawn gives that element its own z-index:0, which traps
  // any child below the card's full-card link overlay (z-index:1) —
  // clicks would silently fall through to the product page link instead
  // of reaching the button. .card__inner has no such isolated stacking
  // context, so its children compare z-index directly against the overlay.
  function getMediaContainer(cardWrapper) {
    return (
      cardWrapper.querySelector('.card__inner') ||
      cardWrapper.querySelector('.card__media') ||
      cardWrapper.querySelector('.media') ||
      cardWrapper
    );
  }

  function setBadge(cardWrapper, inCart) {
    const media = getMediaContainer(cardWrapper);
    const existing = media.querySelector('.quick-add-in-cart-badge');
    if (inCart && !existing) {
      const badge = document.createElement('span');
      badge.className = 'quick-add-in-cart-badge';
      badge.setAttribute('aria-hidden', 'true');
      badge.innerHTML = '&#10003;';
      media.appendChild(badge);
    } else if (!inCart && existing) {
      existing.remove();
    }
  }

  async function refreshBadges(forceRefresh) {
    const cart = await getCart(forceRefresh);
    const cartProductIds = new Set((cart.items || []).map((item) => String(item.product_id)));
    document.querySelectorAll('.card-wrapper').forEach((cardWrapper) => {
      const productId = getProductId(cardWrapper);
      if (!productId) return;
      setBadge(cardWrapper, cartProductIds.has(productId));
    });
  }

  // Updates the cart drawer + header cart icon in the background, without
  // opening the drawer — quick-add from the collection page should only
  // show the toast + fly-to-cart animation, not pop the drawer open.
  function updateCartSectionsSilently(parsedState) {
    if (!parsedState.sections) return;

    const cartDrawerRoot = document.getElementById('CartDrawer');
    if (cartDrawerRoot && parsedState.sections['cart-drawer']) {
      const parsed = new DOMParser()
        .parseFromString(parsedState.sections['cart-drawer'], 'text/html')
        .querySelector('#CartDrawer');
      if (parsed) cartDrawerRoot.innerHTML = parsed.innerHTML;
    }

    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble && parsedState.sections['cart-icon-bubble']) {
      const parsed = new DOMParser()
        .parseFromString(parsedState.sections['cart-icon-bubble'], 'text/html')
        .querySelector('.shopify-section');
      if (parsed) cartIconBubble.innerHTML = parsed.innerHTML;
    }

    const cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) {
      cartDrawerEl.classList.remove('is-empty');
      const inner = cartDrawerEl.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
    }
  }

  // Clones the clicked card's product image and animates it flying toward
  // the header cart icon, shrinking and fading out along the way.
  function flyToCart(imageEl) {
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (!imageEl || !cartIcon) return;

    const startRect = imageEl.getBoundingClientRect();
    const endRect = cartIcon.getBoundingClientRect();
    if (startRect.width === 0 || startRect.height === 0) return;

    const flyer = imageEl.cloneNode(true);
    flyer.style.position = 'fixed';
    flyer.style.top = `${startRect.top}px`;
    flyer.style.left = `${startRect.left}px`;
    flyer.style.width = `${startRect.width}px`;
    flyer.style.height = `${startRect.height}px`;
    flyer.style.margin = '0';
    flyer.style.zIndex = '9999';
    flyer.style.borderRadius = '0.8rem';
    flyer.style.pointerEvents = 'none';
    flyer.style.objectFit = 'cover';
    document.body.appendChild(flyer);

    const deltaX = endRect.left + endRect.width / 2 - (startRect.left + startRect.width / 2);
    const deltaY = endRect.top + endRect.height / 2 - (startRect.top + startRect.height / 2);

    const animation = flyer.animate(
      [
        { transform: 'translate(0, 0) scale(1)', opacity: 1 },
        { transform: `translate(${deltaX}px, ${deltaY}px) scale(0.08)`, opacity: 0.3 },
      ],
      { duration: 700, easing: 'cubic-bezier(0.55, 0, 0.85, 0.35)' }
    );
    animation.onfinish = () => flyer.remove();
    animation.oncancel = () => flyer.remove();
  }

  // Positions the toast directly under the header cart icon (rather than a
  // fixed CSS offset), so it always lines up with it regardless of header
  // height/layout, and the cart icon stays visible and clickable above it.
  function positionToastUnderCartIcon(toast) {
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (!cartIcon) return;
    const rect = cartIcon.getBoundingClientRect();
    const gap = 10;
    toast.style.top = `${Math.round(rect.bottom + gap)}px`;
    toast.style.right = `${Math.round(window.innerWidth - rect.right)}px`;
  }

  function showAddedToCartToast() {
    const existing = document.getElementById('OnhowAddedToast');
    if (existing) existing.remove();
    clearTimeout(window.__onhowToastTimeout);

    const toast = document.createElement('div');
    toast.id = 'OnhowAddedToast';
    toast.className = 'onhow-added-toast';
    toast.innerHTML =
      '<span class="onhow-added-toast__icon" aria-hidden="true">&#10003;</span>' +
      '<span class="onhow-added-toast__text">Erfolgreich in den <a href="/cart" class="onhow-added-toast__link">Warenkorb</a> hinzugef&uuml;gt</span>';
    document.body.appendChild(toast);
    positionToastUnderCartIcon(toast);

    const link = toast.querySelector('.onhow-added-toast__link');
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else {
        window.location.href = link.href;
      }
      toast.classList.remove('is-visible');
      setTimeout(() => toast.remove(), 300);
    });

    requestAnimationFrame(() => toast.classList.add('is-visible'));

    window.__onhowToastTimeout = setTimeout(() => {
      toast.classList.remove('is-visible');
      setTimeout(() => toast.remove(), 300);
    }, 2000);
  }

  function addQuickAddButton(cardWrapper) {
    if (cardWrapper.querySelector('.quick-add-plus')) return;

    // Dawn's card-product.liquid snippet renders both real product cards
    // and plain "collection" cards (e.g. a related-collections strip) with
    // the same shared .card-wrapper class. Only the former has an add-to-
    // cart action — attaching the button to a collection card meant its
    // href (a /collections/... URL) got fetched as `${url}.js` and parsed
    // as a product, crashing on `product.variants[0]` since collections
    // have no variants.
    if (!cardWrapper.classList.contains('product-card-wrapper')) return;

    const link = cardWrapper.querySelector('.card__heading a, a.full-unstyled-link');
    if (!link) return;

    const media = getMediaContainer(cardWrapper);

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'quick-add-plus';
    btn.setAttribute('aria-label', 'In den Warenkorb legen');
    btn.innerHTML =
      `<span class="quick-add-plus__icon">${CART_ICON_SVG}</span>` + '<span class="quick-add-plus__plus" aria-hidden="true">+</span>';

    btn.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (btn.disabled) return;

      // One-off vintage pieces only ever have one unit — if it's already in
      // the cart, adding it again makes no sense. Block it client-side and
      // show a clear "not possible" cue instead of hitting the cart API.
      const productId = getProductId(cardWrapper);
      if (productId) {
        const cart = await getCart(false);
        const cartProductIds = new Set((cart.items || []).map((item) => String(item.product_id)));
        if (cartProductIds.has(productId)) {
          btn.disabled = true;
          btn.classList.add('is-blocked');
          setTimeout(() => {
            btn.classList.remove('is-blocked');
            btn.disabled = false;
          }, 900);
          return;
        }
      }

      btn.disabled = true;
      btn.classList.add('is-loading');

      try {
        const productUrl = link.getAttribute('href').split('?')[0];
        const productRes = await fetch(`${productUrl}.js`);
        const product = await productRes.json();
        const variant = product.variants[0];

        if (!variant || !variant.available) {
          btn.classList.add('is-error');
          setTimeout(() => btn.classList.remove('is-error'), 1200);
          return;
        }

        const cartDrawer = document.querySelector('cart-drawer');
        const formData = new FormData();
        formData.append('id', variant.id);
        formData.append('quantity', '1');

        if (cartDrawer && cartDrawer.getSectionsToRender) {
          formData.append(
            'sections',
            cartDrawer.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
        }

        window.__cartMutationSeq = (window.__cartMutationSeq || 0) + 1;
        const requestSeq = window.__cartMutationSeq;

        const addRes = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        });
        const addJson = await addRes.json();

        if (addJson.status) {
          btn.classList.add('is-error');
          setTimeout(() => btn.classList.remove('is-error'), 1200);
          return;
        }

        if (requestSeq === window.__cartMutationSeq) {
          updateCartSectionsSilently(addJson);
        }

        const imageEl = media.querySelector('img');
        flyToCart(imageEl);
        showAddedToCartToast();

        const cartIcon = document.querySelector('#cart-icon-bubble');
        if (cartIcon) {
          cartIcon.classList.remove('onhow-cart-pulse');
          // eslint-disable-next-line no-void
          void cartIcon.offsetWidth;
          cartIcon.classList.add('onhow-cart-pulse');
          setTimeout(() => cartIcon.classList.remove('onhow-cart-pulse'), 400);
        }

        refreshBadges(true);

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'collection-quick-add', cartData: addJson });
        }
      } catch (error) {
        console.error(error);
      } finally {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      }
    });

    media.appendChild(btn);
  }

  function init() {
    document.querySelectorAll('.card-wrapper').forEach(addQuickAddButton);
    refreshBadges(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function initCartUpdateSubscription() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => refreshBadges(true));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartUpdateSubscription);
  } else {
    initCartUpdateSubscription();
  }

  const grid = document.getElementById('product-grid') || document.body;
  const observer = new MutationObserver(() => init());
  observer.observe(grid, { childList: true, subtree: true });
})();
